// Reusable US Letter (landscape) Thrive Market packing list (DOSS PO-v4 design); mapped identity.
// Generated by scripts/wms/generate.ts for PHP-424. Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomThrivePackingListFileDataSchema = yup.object().shape({
  customerDisplayName: yup.string().nullable().optional(),
  customerBrandSubtitle: yup.string().nullable().optional(),
  poNumber: yup.string().nullable().optional(),
  carrier: yup.string().nullable().optional(),
  requestedDate: yup.string().nullable().optional(),
  arrivalDate: yup.string().nullable().optional(),
  vendorName: yup.string().nullable().optional(),
  vendorAddress: yup.string().nullable().optional(),
  shipToName: yup.string().nullable().optional(),
  shipToAddress: yup.string().nullable().optional(),
  billToName: yup.string().nullable().optional(),
  billToAddress: yup.string().nullable().optional(),
  totalPalletsShipped: yup.string().nullable().optional(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        itemNumber: yup.string().nullable().optional(),
        orderedUpc: yup.string().nullable().optional(),
        itemDescription: yup.string().nullable().optional(),
        orderedEaches: yup.string().nullable().optional(),
        orderedCases: yup.string().nullable().optional(),
        shippedEaches: yup.string().nullable().optional(),
        shippedCases: yup.string().nullable().optional(),
        lotCode: yup.string().nullable().optional(),
        expiration: yup.string().nullable().optional(),
      }),
    )
    .required(),
})

export type BiomThrivePackingListFileData = yup.InferType<
  typeof biomThrivePackingListFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<BiomThrivePackingListFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomThrivePackingListFileMappings: RequiredFileData = {
  customerDisplayName: '0f25a05d-b14a-4620-a8e3-760b4bf405fd',
  customerBrandSubtitle: '7a8a9257-29f5-4493-85c2-6073eb50e6bd',
  poNumber: 'd0d87b9a-6ed2-4472-85ce-16be6dadd254',
  carrier: 'cec0e428-de97-4ccb-80ab-b5364e36564f',
  requestedDate: 'e2bc3ec3-5642-4e5e-9e62-82985bf77975',
  arrivalDate: '42eae13e-af18-45da-bd22-c326031f680b',
  vendorName: 'b87be76c-713b-4783-90fa-2cb9d09f6568',
  vendorAddress: '5e955f79-d6c5-48ae-b7fb-ceb231c0accc',
  shipToName: '882fd1e9-d331-4a84-bd55-b0af6ab98418',
  shipToAddress: 'e8d9a3e3-f141-46d7-b711-d3b27080f17e',
  billToName: '6372bf20-ee09-4d01-bdb9-d9c1f2556b90',
  billToAddress: '20b7596b-6f90-4b9f-81ba-a76f81122857',
  totalPalletsShipped: 'c158c803-909f-459f-b235-b44bf01972f5',
  items: [
    {
      itemNumber: 'f2a7d5f1-2368-44ed-9a02-c4539a7e81a8',
      orderedUpc: 'b118cadc-56a0-496a-8774-e575e061208a',
      itemDescription: '3897dafa-2e3e-4352-885b-b2595434d78b',
      orderedEaches: 'c8ae9a7b-d322-4a46-bb5e-78979a861f0b',
      orderedCases: 'da5e64cf-cac8-4f6c-8ad2-17a800bdebf2',
      shippedEaches: 'fa45a18e-aab2-4e17-8163-5aa23fd81170',
      shippedCases: '836163a9-f391-45e0-bc6d-c0a34d7b939b',
      lotCode: '8f8cd9bd-8b50-4564-8fe6-7808b5d05e60',
      expiration: 'd98e9f14-606a-4373-ab64-fede8d7a1936',
    },
  ],
}
